import React from "react";
import { CiSearch } from "react-icons/ci";
import { useSelector } from "react-redux";
import { useTheme } from "../../../Themecontext/Themecontext";

const PayRollFilterBox = ({
  title,
  items = [],
  search,
  setSearch,
  selectedItems = [],
  toggleItem,
  selectAll,
}) => {
  const filteredItems = items.filter((item) =>
    item?.label?.toLowerCase().includes(search.toLowerCase()),
  );

  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  return (
    <>
      <style>{`
          .hover-scale-btn {
            transition: transform 0.2s ease-in-out;
            transform: scale(1);
          }
  
          .hover-scale-btn:hover {
            transform: scale(1.02);
          }
           .search-input::placeholder {
              color: ${isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour12};
              opacity: 1;
        }
.search-input:focus{
  border-color: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour7
        } !important;

  box-shadow: 0 0 0 0.2rem ${isdark === "light" ? `${iscolour?.Colour7}40` : `${iscolourDark?.Colour7}40`
        } !important;

  outline: none !important;
        `}</style>
      <div
        style={{
          width: "100%",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour4}`,
          borderRadius: "12px",
          overflow: "hidden",
          backgroundColor:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
          boxSizing: "border-box",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            padding: "18px 22px",
          }}
        >
          <h3
            style={{
              fontWeight: "700",
              fontSize: "18px",
              margin: 0,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
            }}
          >
            {title}
          </h3>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "12px 22px",
          }}
        >
          <style>
            {`
   
  `}
          </style>
          <div style={{ position: "relative", marginBottom: "12px" }}>
            <span
              style={{
                position: "absolute",
                left: "14px",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "18px",
                color:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour12,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CiSearch />
            </span>

            <input
              type="text"
              placeholder="Search..."
              value={search}
              className="search-input"
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: "100%",
                height: "44px",
                padding: "6px 12px 6px 42px",
                border: `1px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour5
                  }`,
                borderRadius: "8px",
                background: isdark === "light" ? "#fff" : iscolourDark?.Colour3,
                color: isdark === "light" ? "#000" : "#fff",
                outline: "none",
                boxSizing: "border-box",
              }}
            />
          </div>

          <button
            className="hover-scale-btn "
            onClick={selectAll}
            style={{
              width: "100%",
              height: "48px",
              backgroundColor:
                isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
              borderRadius: "10px",
              border: "none",
              marginBottom: "12px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
           {Array.isArray(selectedItems) &&
              selectedItems.length === items.length &&
              items.length > 0
              ? "Deselect All"
              : "Select All"}
          </button>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              height: "210px",
              overflowY: "auto",
              overflowX: "hidden",
              paddingRight: "8px",
              scrollbarWidth: "thin",
              scrollbarColor:
                isdark === "light"
                  ? `${iscolour?.Colour5} ${iscolour?.Colour3}`
                  : `${iscolourDark?.Colour8} ${iscolourDark?.Colour4}`,
            }}
          >
            {filteredItems.length > 0 ? (
              filteredItems.map((item, index) => {
                const isSelected =
                  title === "Account Name"
                    ? selectedItems === item.value
                    : selectedItems.includes(item.value);

                return (
                  <div
                    key={index}
                    onClick={() => toggleItem(item)}
                     style={{
                      padding: "10px 12px",
                      borderRadius: "10px",
                      cursor: "pointer",
                      transition: "all 0.3s ease-in-out",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: isSelected
                        ? isdark === "light"
                          ? iscolour?.Colour3
                          : iscolourDark?.Colour3
                        : isdark === "light"
                          ? iscolour?.Colour3
                          : iscolourDark?.Colour3,
                      color: isSelected
                        ? isdark === "light"
                          ? "#000"
                          : "#ffff"
                        : isdark === "light"
                          ? iscolour?.Colour12
                          : iscolourDark?.Colour11,
                      border: isSelected
                        ? `2px solid ${isdark === "light"
                          ? iscolour?.Colour4
                          : iscolourDark?.Colour5
                        }`
                        : `2px solid ${isdark === "light"
                          ? iscolour?.Colour4
                          : iscolourDark?.Colour5
                        }`,
                      fontSize: "15px",
                      fontWeight: 500,
                      boxSizing: "border-box",
                    }}
                  >
                    <span>{item?.label}</span>

                    {isSelected && (
                      <svg
                        style={{
                          height: "20px",
                          width: "20px",
                          marginLeft: "8px",
                          flexShrink: 0,
                        }}
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    )}
                  </div>
                );
              })
            ) : (
              <p
                style={{
                  color: "#6b7280",
                  fontSize: "14px",
                  textAlign: "center",
                  margin: 0,
                  padding: "10px 0",
                }}
              >
                No items found.
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PayRollFilterBox;
